import validate from 'validate.js';
import { FormattedMessage } from 'react-intl';
import React from 'react';

const validateCancelBookingForm = (values) => {
  const {
    cancelReason,
    messageToHost,
    otherReason
  } = values;

  return {
    cancelReason: validate.single(cancelReason, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox_cancel_booking.validate_cancel_booking_form.select_option' defaultMessage='Please select an option.' />
      }
    }),
    otherReason: validate.single(otherReason, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox_cancel_booking.validate_cancel_booking_form.enter_message_other' defaultMessage='Please enter a message.' />
      },
      length: {
        minimum: 6,
        tooShort: <FormattedMessage id='inbox_cancel_booking.validate_cancel_booking_form.other_minimum' defaultMessage='Minimum is 6 characters' />,
        maximum: 10000,
        tooLong: <FormattedMessage id='inbox_cancel_booking.validate_cancel_booking_form.other_maximum' defaultMessage='Maximum is %{count} characters' />
      }
    }),
    messageToHost: validate.single(messageToHost, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox_cancel_booking.validate_cancel_booking_form.to_host_enter_message' defaultMessage='Please enter a message.' />
      },
      length: {
        minimum: 6,
        tooShort: <FormattedMessage id='inbox_cancel_booking.validate_cancel_booking_form.to_host_minimum' defaultMessage='Minimum is 6 characters.' />,
        maximum: 10000,
        tooLong: <FormattedMessage id='inbox_cancel_booking.validate_cancel_booking_form.to_host_maximum' defaultMessage='Maximum is 10000 characters.' />
      }
    })
  };
};

export default validateCancelBookingForm;
